import React from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "./Footer";
import NavbarWithPushContent from "./NavbarWithPushContent";
import Navbar from "./Navbar";
import ErrorComponent from "../Assets/ErrorComponent";
import LoadingSpinner from "../Assets/LoadingSpinner";
import { useParenProducts } from "../Hooks/useParentProducts";
import useAdminOTC from "../Hooks/useAdminOTC";
import { useTranslation } from "react-i18next";
import NotFound from "../Assets/NotFound";
import Seo from "../Assets/Seo";

interface ProductDetailProps {
    products: any[];
    lang: string;
}

const ParentCategory: React.FC<ProductDetailProps> = ({ products, lang }) => {
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();


    const { data: parentData, loading: parentLoading, error: parentError } = useParenProducts(id || "", lang);
    const { products: otcData, loading: otcLoading, error: otcError } = useAdminOTC(20, id || "");


    // Determine which data to use based on the id
    const data = id === "Herbal Products" ? otcData : parentData;
    const loading = id === "Herbal Products" ? otcLoading : parentLoading;
    const error = id === "Herbal Products" ? otcError : parentError;

    if (loading) return <LoadingSpinner />;
    if (error) return <ErrorComponent message={error} />;


    return (
        <div className="min-h-screen flex flex-col">
            <Seo
                title={id ? t(`subcategories.${id}`, { defaultValue: t("seo.products.title") }) : t("seo.products.title")}
                description={t("seo.products.description")}
                lang={lang}
            />
            <div className="hidden md:block">
                <NavbarWithPushContent products={products} lang={lang} />
            </div>

            <div className="block md:hidden">
                <Navbar products={products} lang={lang} />
            </div>

            <section className="block bg-gray-100 px-4 pt-24 md:pt-28 pb-10 md:pb-60">
                <div className="max-w-6xl mx-auto relative z-10">
                    <div className="bg-white py-10 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-7xl mx-auto">
                            <h1 className="text-4xl font-bold text-center text-emerald-600 mb-10">
                                {/* {data.parent === "Medicinal Products" ? "a" : 'b'} */}
                            </h1>

                            {/* Check if the data has subcategories */}
                            {data.subcategories ? (
                                data.subcategories.map((subcategory: any) => (
                                    <div key={subcategory.name} className="mb-14">
                                        <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
                                            {t(`subcategories.${subcategory.name}`)}
                                        </h2>

                                        <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                                            {subcategory.products.map((product: any) => (
                                                <Link
                                                    to={`/product/${product._id}`}
                                                    className="bg-white shadow-md rounded-2xl overflow-hidden border hover:shadow-lg transition-shadow"
                                                    key={product._id}>
                                                    <img
                                                        src={product.image}
                                                        alt={product.name[lang]}
                                                        className="w-full h-48 object-contain p-4 bg-gray-50"
                                                    />
                                                    <div className="p-5">
                                                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                                                            {product.name[lang]}
                                                        </h3>

                                                        <p className="mt-4 text-sm font-medium text-emerald-600">
                                                            {product.dosage[lang]}
                                                        </p>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="mb-14">
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
                                        {t(`products.herbal`)}
                                    </h2>
                                    <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">

                                        {data.map((product: any) => (
                                            <Link
                                                to={`/product/${product._id}`}
                                                className="bg-white shadow-md rounded-2xl overflow-hidden border hover:shadow-lg transition-shadow"
                                                key={product._id}>
                                                <img
                                                    src={product.image}
                                                    alt={product.name[lang]}
                                                    className="w-full h-48 object-contain p-4 bg-gray-50"
                                                />
                                                <div className="p-5">
                                                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                                                        {product.name[lang]}
                                                    </h3>

                                                    <p className="mt-4 text-sm font-medium text-emerald-600">
                                                        {product.dosage[lang]}
                                                    </p>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ParentCategory;
